import { z } from 'zod';
import { idSchema } from './common.js';
export const invoiceAccountingKindSchema = z.enum(['STANDARD', 'ADVANCE_REQUEST', 'FINAL']);
export const advanceInvoiceIdsSchema = z
    .array(idSchema)
    .max(100)
    .refine((ids) => new Set(ids).size === ids.length, 'invoice.advance.duplicate');
//# sourceMappingURL=advance-invoice.js.map